import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../context/UseContext";
import { Avatar } from "../Avatar";
import Points from "../points/Points";

function SettingsHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const { profile } = useContext(UserContext);

  return (
    <div>
      <header className="flex justify-between items-center">
        <h3 className="text-3xl font-bold">
          {location?.pathname.includes("help")
            ? "Frequently Asked Question"
            : location?.pathname.includes("security")
            ? "Security"
            : "Settings"}
        </h3>

        {profile?.profile_image ? (
          <div
            onClick={() => navigate("/settings/profile")}
            className="p-0.5 border-gradient rounded-full w-fit cursor-pointer"
          >
            <img
              className="w-10 h-10 object-cover rounded-full"
              src={profile?.profile_image}
              alt="Profile_image"
              loading="lazy"
            />
          </div>
        ) : (
          <Avatar
            onClick={() => navigate("/settings/profile")}
            firstName={profile?.first_name}
            lastName={profile?.last_name}
          />
        )}
      </header>
      <div className="flex items-center justify-end mt-2">
        <Points className="bg-[#00000066]" userPoints={profile?.points} />
      </div>
    </div>
  );
}

export default SettingsHeader;
